<template>
  <div v-if="this.userLogin.company_id != 0">
    <v-card elevation="2">
      <v-card-title>
        List API Keys
        <v-spacer></v-spacer>
        <v-btn color="primary" small dark class="mb-2" @click="generateAPIKey">
          <md-icon style="cursor: pointer; padding-right: 0.3em;color: #fff;"
            >refresh</md-icon
          >
          Generate
        </v-btn>
      </v-card-title>
      <v-data-table
        disable-pagination
        :headers="headers"
        :items="APIKeys"
        class="elevation-1"
        :hide-default-footer="true"
      >
        <!-- <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>List API Keys</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" small dark class="mb-2" v-on="on"
                  >Add New</v-btn
                >
              </template>
            </v-dialog>
          </v-toolbar>
        </template> -->
        <template v-slot:[`item.api_keys`]="{ item }">
          {{ item.api_keys.substr(0, 50) }}...
          <span @click="copyTestingCode(item.api_keys)"
            ><md-icon style="cursor: pointer;">content_copy</md-icon></span
          >
        </template>
        <template v-slot:[`item.user_id`]="{ item }">
          {{ item.user.name }} ({{ item.user.roles[0].name }})
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <!-- <v-icon small @click="editItem(item)">edit</v-icon> -->
          <v-icon color="red" small @click="deleteItem(item)">delete</v-icon>
        </template>
        <template v-slot:no-data>
          <span class="text-center">No data available.</span>
        </template>
      </v-data-table>
      <div style="padding:20px;" class="d-flex">
        <v-col class="d-flex" cols="12" sm="1">
          <small style="margin-top:30px;">Item show</small>
        </v-col>
        <v-col class="d-flex" cols="12" sm="1">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            @change="handlePageSizeChange"
            style="font-size:10px;"
          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
          <v-pagination
            style="width:auto;"
            v-model="currentPage"
            :length="totalPages"
            total-visible="10"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
            @input="handlePageChange"
          ></v-pagination>
          <small style="margin-top:28px;"
            >{{ from }}-{{ to }} of {{ totalData }}</small
          >
        </v-col>
      </div>
    </v-card>
  </div>
  <div v-else class="content">
    <div class="md-layout">
      <nav-tabs-card>
        <template slot="content">
          <h3 class="text-center">
            Silahkan tambahkan data company profile terlebih dahulu
          </h3>
        </template>
      </nav-tabs-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import { NavTabsCard } from "@/components";
import { userHaveRoles } from "@/services/utilities";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { formatCurrency } from "@/libs/number";
import dayjs from "dayjs";

export default {
  components: {
    NavTabsCard,
  },
  data: () => ({
    dialog: false,
    dialogVerify: false,
    headers: [
      {
        text: "API Key",
        align: "left",
        value: "api_keys",
      },
      { text: "User Scope", value: "user_id" },
      { text: "Actions", value: "action", sortable: false },
    ],
    item_users: [],
    roles: [],
    APIKeys: [],
    inputSearch: null,
    newUser: false,
    userFound: false,
    haveCompany: false,
    userLogin: {},
    editedIndex: -1,
    defaultItem: {
      name: "",
      username: "",
      telp: "",
      email: "",
      roles: [
        {
          id: "",
          name: "",
        },
      ],
    },
    labelActivated: {
      0: {
        status: "Not Active",
        color: "#E53935",
      },
      1: {
        status: "Active",
        color: "#0277BD",
      },
    },

    pageSizes: [10, 50, 100],
    currentPage: 1,
    totalPages: 0,
    pageSize: 10,
    from: 0,
    to: 0,
    totalData: 0,
  }),

  computed: {
    ...mapGetters({
      getRoles: "user/getRoles",
      getUsersUnverified: "user/getUsersUnverified",
      getApiKeys: "api_key/getApiKeys",
    }),

    formTitle() {
      return this.editedIndex === -1 ? "New API Key" : "Edit API Key";
    },
    computedHeaders() {
      let editedHeaders = this.headers;

      return editedHeaders;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      createUser: "user/createUser",
      updateUser: "user/updateUser",
      dataUsers: "user/getUsers",
      storeApiKeys: "api_key/storeApiKeys",
      deleteApiKeys: "api_key/deleteApiKeys"
    }),

    convertCurrency(total) {
      return "Rp. " + formatCurrency(total);
    },

    parserDateOnly(date) {
      return dayjs(date).format("DD-MM-YYYY");
    },

    copyTestingCode(str) {
      try {
        const el = document.createElement("textarea");
        el.value = str;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);

        this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Success!",
          text: "API Keys was copied!",
        });
      } catch (err) {
        this.$notify({
          group: "custom-notification",
          type: "error",
          title: "Error!",
          text: "Oops! unable to copy",
        });
      }
    },

    async handlePageChange(value) {
      this.item_users = [];
      this.currentPage = value;
      const getUsers = await this.dataUsers({
        page: this.currentPage,
        jum: this.pageSize,
      });
      this.totalPages = getUsers.data.attributes.last_page;
      this.currentPage = getUsers.data.attributes.current_page;
      this.from = getUsers.data.attributes.from;
      this.to = getUsers.data.attributes.to;
      this.totalData = getUsers.data.attributes.total;

      if (userHaveRoles(["super_admin"])) {
        forEach(getUsers.data.attributes.data, (user) => {
          if (user.roles.filter((role) => role.name === "entity").length) {
            this.item_users.push(user);
          }
        });
      } else if (userHaveRoles(["entity"])) {
        forEach(getUsers.data.attributes.data, (user) => {
          if (user.roles.filter((role) => role.name !== "entity").length) {
            this.item_users.push(user);
          }
        });
      } else if (userHaveRoles(["admin"])) {
        forEach(getUsers.data.attributes.data, (user) => {
          if (
            user.roles.filter(
              (role) => role.name !== "admin" && role.name !== "entity"
            ).length
          ) {
            this.item_users.push(user);
          }
        });
      } else {
        forEach(getUsers.data.attributes.data, (user) => {
          if (user.roles.filter((role) => role.name !== "entity").length) {
            this.item_users.push(user);
          }
        });
      }

      for (let role of getRoles.data.attributes) {
        if (userHaveRoles(["super_admin"])) {
          if (role.name == "entity" || role.name == "verified") {
            this.roles.push({
              name: role.name,
              id: role.id,
            });
          }
        } else if (userHaveRoles(["entity"])) {
          if (
            role.name != "entity" &&
            role.name != "super_admin" &&
            role.name != "unverified" &&
            role.name != "verified"
          ) {
            this.roles.push({
              name: role.name,
              id: role.id,
            });
          }
        } else {
          if (
            role.name != "entity" &&
            role.name != "super_admin" &&
            role.name != "unverified" &&
            role.name != "verified" &&
            role.name != "admin"
          ) {
            this.roles.push({
              name: role.name,
              id: role.id,
            });
          }
        }
      }
    },

    async handlePageSizeChange(size) {
      this.item_users = [];
      this.pageSize = size;
      this.currentPage = 1;
      const getUsers = await this.dataUsers({
        page: this.currentPage,
        jum: this.pageSize,
      });
      this.totalPages = getUsers.data.attributes.last_page;
      this.currentPage = getUsers.data.attributes.current_page;
      this.from = getUsers.data.attributes.from;
      this.to = getUsers.data.attributes.to;
      this.totalData = getUsers.data.attributes.total;

      if (userHaveRoles(["super_admin"])) {
        forEach(getUsers.data.attributes.data, (user) => {
          if (user.roles.filter((role) => role.name === "entity").length) {
            this.item_users.push(user);
          }
        });
      } else if (userHaveRoles(["entity"])) {
        forEach(getUsers.data.attributes.data, (user) => {
          if (user.roles.filter((role) => role.name !== "entity").length) {
            this.item_users.push(user);
          }
        });
      } else if (userHaveRoles(["admin"])) {
        forEach(getUsers.data.attributes.data, (user) => {
          if (
            user.roles.filter(
              (role) => role.name !== "admin" && role.name !== "entity"
            ).length
          ) {
            this.item_users.push(user);
          }
        });
      } else {
        forEach(getUsers.data.attributes.data, (user) => {
          if (user.roles.filter((role) => role.name !== "entity").length) {
            this.item_users.push(user);
          }
        });
      }

      for (let role of getRoles.data.attributes) {
        if (userHaveRoles(["super_admin"])) {
          if (role.name == "entity" || role.name == "verified") {
            this.roles.push({
              name: role.name,
              id: role.id,
            });
          }
        } else if (userHaveRoles(["entity"])) {
          if (
            role.name != "entity" &&
            role.name != "super_admin" &&
            role.name != "unverified" &&
            role.name != "verified"
          ) {
            this.roles.push({
              name: role.name,
              id: role.id,
            });
          }
        } else {
          if (
            role.name != "entity" &&
            role.name != "super_admin" &&
            role.name != "unverified" &&
            role.name != "verified" &&
            role.name != "admin"
          ) {
            this.roles.push({
              name: role.name,
              id: role.id,
            });
          }
        }
      }
    },

    async initialize() {
      const getApiKeys = await this.getApiKeys;
      this.APIKeys = getApiKeys;
      const getRoles = await this.getRoles;
      this.userLogin = JSON.parse(window.localStorage.getItem("user_data"));
    },

    convertCurrency(total) {
      return "Rp. " + formatCurrency(total);
    },

    editItem(item) {
      this.editedIndex = this.item_users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (this.editedItem.password != "" || this.editedItem.password != null) {
        delete this.editedItem.password;
      }

      this.newUser = true;
      this.dialog = true;
    },

    async deleteItem(item) {
      const index = this.APIKeys.indexOf(item);

      if (confirm("Are you sure you want to delete this data?")) {
        await this.deleteApiKeys(item.id)
        this.APIKeys.splice(index, 1);
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.haveCompany = false;
        this.userFound = false;
        this.newUser = false;
        this.inputSearch = "";
        this.editedItem.name = "";
        this.editedItem.email = "";
        this.editedItem.telp = "";
        this.editedItem.roles[0].id = "";
        this.editedIndex = -1;
      }, 300);
    },

    async save() {
      let response;
      if (this.editedIndex > -1) {
        try {
          this.editedItem.activated = 1;
          if (
            this.editedItem.password == "" ||
            this.editedItem.password == null
          ) {
            delete this.editedItem.password;
          }
          response = await this.updateUser(this.editedItem);
          Object.assign(
            this.item_users[this.editedIndex],
            response.data.attributes
          );
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Success update User!",
          });
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          const role = this.roles.find(
            (role) => role.id === this.editedItem.roles[0].id
          );
          if (this.userFound) {
            // console.log('this.editedItem', this.editedItem)
            this.editedItem.activated = 1;
            response = await this.updateUser(this.editedItem);
            // const role = this.roles.find(role => role.id === this.editedItem.roles[0].id)
            // this.editedItem.roles = []
            // this.editedItem.roles.push(role)
            this.item_users.splice(0, 0, response.data.attributes);
          } else {
            if (this.editedItem.password !== this.editedItem.password_conf) {
              return alert("Password tidak cocok!");
            } else {
              response = await this.createUser(this.editedItem);
              this.$notify({
                group: "custom-notification",
                type: "success",
                title: "Success!",
                text: "Success create new User!",
              });
            }

            // this.editedItem.roles = []
            // this.editedItem.roles.push(role)
            this.item_users.splice(0, 0, response.data.attributes.user);
          }
        } catch (e) {
          console.log(e);
        }
      }
      // console.log('response', response)
      this.close();
    },

    async generateAPIKey() {
      const result = await this.storeApiKeys();
      this.APIKeys.push(result);
    },
  },
};
</script>
<style scoped>
.rounded-circle {
  border-radius: 100%;
  padding: 0 !important;
  min-width: 15px !important;
  box-shadow: none;
}
</style>
